"use client";




export default function InteriorBanner() {
  // Navigation links data
  const breadcrumbs = [
    { label: "AetherSIm", href: "/", active: false },
    { label: "Canada eSIM Plans", href: "/canada", active: true },
  ];

  return (
    <div className="pt-36 pb-14 w-full bg-card border-b-2 shadow-sm relative overflow-hidden">
      <div className="w-full max-w-7xl mx-auto px-4 lg:px-0 flex flex-col items-start gap-4">
        {/* Topper text with line */}
        <div className="relative">
          <span className="text-sm font-bold uppercase tracking-wider text-card-foreground">
            Find the plan for you{" "}
          </span>
          {/* Line extending to the left */}
          <div className="absolute top-1/2 right-full w-full mr-3 h-0.5 bg-card-foreground transform -translate-y-1/2" />
        </div>

        {/* Main title */}
        <h1 className="text-4xl md:text-5xl lg:text-7xl font-black text-card-foreground leading-tight">
          Canada Data price chart
        </h1>

        {/* Breadcrumbs */}
        <div className="flex items-center justify-center">
          {breadcrumbs.map((crumb, index) => (
            <div key={index} className="flex items-center text-card-foreground">
              <a
                href={crumb.href}
                className="text-base lg:text-lg hover:opacity-80 transition-opacity"
              >
                <span>{crumb.label}</span>
              </a>
              {index < breadcrumbs.length - 1 && (
                <div className="w-[1.8rem] h-0.5 bg-card-foreground mx-3 lg:mx-6" />
              )}
            </div>
          ))}
        </div>
      </div>
    </div>
  );
}
